import { useTranslation } from 'react-i18next';
import { ErrorBoundary } from '@sentry/react';

function MaintenanceMode() {
  const { t } = useTranslation('other');
  return (
    <ErrorBoundary
      fallback={({ error, componentStack }) => (
        <>
          <div>You have encountered an error</div>
          <div>{error.toString()}</div>
          <div>{componentStack}</div>
        </>
      )}
    >
      <div className="container mx-auto">
        <div className="p-4">
          <div
            className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative"
            role="alert"
          >
            <strong className="font-bold">
              {t('other:maintenance-mode1')}
            </strong>
            <span className="block sm:inline"> </span>
            <span className="block sm:inline">
              {t('other:maintenance-mode2')}
            </span>
          </div>
        </div>
      </div>
    </ErrorBoundary>
  );
}

export default MaintenanceMode;
